import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import es from 'element-plus/es/locale/lang/es'  // Updated import path
import 'element-plus/dist/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import '@fortawesome/fontawesome-free/css/all.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import ElementTiptapPlugin from 'element-tiptap-vue3-fixed';
// import ElementTiptap's styles
import 'element-tiptap-vue3-fixed/lib/style.css';

library.add(fas)
library.add(far)
library.add(fab)

let app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.component('font-awesome-icon', FontAwesomeIcon); // Aquí le das un nombre al componente
app.use(store)
   .use(router)
   .use(ElementPlus, { locale: es })  // Updated locale configuration
   .use(ElementTiptapPlugin)
   .mount('#app')
